import { UpsertMerchantUserSettings } from './upsert-user-merchant';
import { UpsertUserTeamLead } from './upsert-user-team-lead';
import { UpsertTraderUserSettings } from './upsert-user-trader';
import { UserRole } from './user-role';

export interface UpsertUserData {
    id?: number;
    role: UserRole;
    email: string;
    username: string;
    description?: string;
    teamLeadId: number | null;
    settings?: UpsertTraderUserSettings | UpsertMerchantUserSettings | UpsertUserTeamLead;
}

export interface UpsertUserModalRole {
    key: string;
    value: unknown;
}

export enum UserUpsertModalType {
    CREATE = 'create',
    EDIT = 'edit',
    READ = 'read'
}

export interface UpsertUserModalData {
    type: UserUpsertModalType;
    userDetails?: UpsertUserData;
    onSuccess?: () => void;
}
